<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix">
      <div id="main_area">
        <div style="clear: both"></div>
        <div class="information">
          <h3>S702系統排程執行記錄查詢-查詢條件</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tbody>
                <tr>
                  <td>程式代碼</td>
                  <td>
                    <input
                      type="text"
                      v-model="form.PRGCODE"
                      size="20"
                      maxlength="20"
                    />
                  </td>
                  <td>程式名稱</td>
                  <td>
                    <input
                      type="text"
                      v-model="form.PRGNAME"
                      size="50"
                      maxlength="50"
                    />
                  </td>
                </tr>
                <tr>
                  <td>排程名稱</td>
                  <td colspan="3">
                    <p>
                      <input
                        type="text"
                        v-model="form.BATNM"
                        size="20"
                        maxlength="20"
                      />
                    </p>
                  </td>
                </tr>
                <tr>
                  <td colspan="6" class="f_center">
                    <label for="checkbox"
                      ><span>
                        <input
                          type="submit"
                          class="btn"
                          value="查詢"
                          @click="btnQuery()"
                        />
                        <input
                          type="submit"
                          class="btn"
                          value="重填"
                          @click="btnFormClear()"
                        /> </span
                    ></label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="f_center"></div>
        </div>
        <div class="information">
          <table width="100%" v-if="grid && grid.paginaiton">
            <tbody>
              <tr>
                <td align="right">
                  <input
                    type="button"
                    value="<<"
                    class="btn"
                    style="height: 28px"
                    @click="form.currentpage = grid.paginaiton.pageNo - 1"
                    v-show="grid.paginaiton.pageNo > 1"
                  />
                  <span
                    v-for="(data, index) in grid.paginaiton.pages"
                    :key="index"
                    style="cursor: pointer"
                    :style="
                      grid.paginaiton.pageNo == data
                        ? 'color:red'
                        : 'color:black'
                    "
                    @click="form.currentpage = parseInt(data)"
                  >
                    {{
                      grid.paginaiton.pageNo == data ? "[" + data + "]" : data
                    }}
                  </span>
                  <input
                    type="button"
                    class="btn"
                    value=">>"
                    style="height: 28px"
                    v-show="grid.paginaiton.pageNo < grid.paginaiton.totalPage"
                    @click="form.currentpage = grid.paginaiton.pageNo + 1"
                  />
                  ［每頁<input
                    type="text"
                    v-model.number.lazy="form.pagesize"
                    size="2"
                    maxlength="4"
                  />

                  <input type="button" class="btn" value="筆" />，第<input
                    type="text"
                    v-model.number.lazy="form.currentpage"
                    size="2"
                    maxlength="4"
                  />
                  <input type="button" class="btn" value="頁" />，共
                  {{ grid.paginaiton.totalPage }} 頁
                  {{ grid.paginaiton.totalCount }} 筆］
                </td>
              </tr>
            </tbody>
          </table>
          <div class="active">
            <div class="table_scroll2">
              <table width="1060" class="itable">
                <thead>
                  <tr>
                    <th>記錄</th>
                    <th>排程名稱</th>
                    <th>執行程式名稱</th>
                    <th>開始執行時間</th>
                    <th>結束執行時間</th>
                    <th>狀態</th>
                  </tr>
                </thead>
                <tbody v-if="grid && grid.gridDatas && grid.gridDatas.length">
                  <tr v-for="(data, index) in grid.gridDatas" :key="index">
                    <td width="1%" align="center">
                      <input
                        type="button"
                        class="btn"
                        value="查"
                        @click="btnShowLogModal(data)"
                      />
                    </td>
                    <td>{{data.batnm}}</td>
                    <td>{{data.prgname}}</td>
                    <td>{{data.execsdtime}}</td>
                    <td>{{data.execedtime}}</td>
                    <td>{{data.status}}</td>
                  </tr>
                </tbody>
                <tbody v-else-if="grid.paginaiton">
                  <tr>
                    <td colspan="9" style="text-align: center">查無資料</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- 查詢結果結束-->
        </div>
      </div>
    </div>
    <CyFooter />

    <Modal
      v-model="Modal.show"
      :title="Modal.title"
      :modalStyle="{ 'max-width': '1200px' }"
      :ServiceUnit="Modal.ServiceUnit"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>&nbsp;</td>
                <td>
                  <textarea
                    cols="120"
                    rows="10"
                    v-model="Modal.form.MESSAGE"
                  ></textarea
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </Modal>

    <Alert
      v-model="Alert.show"
      :title="Alert.title"
      :ServiceUnit="pageData.ServiceUnit"
    >
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import CyFooter from "@/components/Common/CyFooter.vue";
import { getMenuIndex } from "@/config/util.js";
import { S702_SearchGrid } from "@/service/api.js";
export default {
  name: "S702",
  data: function () {
    return {
      pageData: {
        MenuIndex: 3,
        PrgName: "S702",
        ServiceUnit: "CY",
        isForceLoginOut: true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      form: {
        PRGCODE: "",
        PRGNAME: "",
        BATNM: "",
        currentpage: 1,
        pagesize: 10,
      },
      grid: {},
      Modal: {
        show: false,
        title: "",
        PreData: {},
        form: { MESSAGE : ''},
        grid: {},
      },
      Alert: {
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.show = false;
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    CyFooter,
    Modal: VueModal,
    Alert: VueModal,
  },
  methods: {
    //分頁防呆檢查
    checkPage: function (currentpage, pagesize) {
      const self = this;
      let pageErrorMsg = [];
      if (currentpage) {
        if (isNaN(parseInt(currentpage))) {
          pageErrorMsg.push("頁數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫頁數");
      }
      if (pagesize) {
        if (isNaN(parseInt(pagesize))) {
          pageErrorMsg.push("筆數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫每頁筆數");
      }
      if (pageErrorMsg.length) {
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = pageErrorMsg;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
        return false;
      }
      return true;
    },
    //第一頁
    btnQuery: function () {
      const self = this;
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = self.form;
      postData.ServiceUnit = self.pageData.ServiceUnit;
      postData.LogInfo.Id = self.loginInfo.id;
      postData.LogInfo.PrgCode = self.loginInfo.PrgName;
      postData.LogInfo.ActCd = "查詢";
      postData.LogInfo.Token = self.loginInfo.token;
      postData.LogInfo.ServiceUnit = self.pageData.ServiceUnit;
      S702_SearchGrid(postData).then((rData) => {
        self.grid = rData.returnObject;
        self.grid.gridDatas.forEach((x) => {
          x.execsdtime = self
            .$moment(x.execsdtime)
            .format("YYYYMMDD HH:mm:ss");
          x.execedtime = self
          .$moment(x.execedtime)
          .format("YYYYMMDD HH:mm:ss");
        });
      });
    },
    //重填
    btnFormClear: function () {
      this.form = {
        PRGCODE: "",
        PRGNAME: "",
        BATNM: "",
        currentpage: 1,
        pagesize: 10,
      };
    },
    btnShowLogModal:function(data){
      const self = this;
      self.Modal.show = true;
      self.Modal.title = "S702系統排程執行記錄查詢-執行記錄";
      self.Modal.PreData = data;
      self.Modal.form.MESSAGE = data.message;
    },
  },
  watch: {
    "form.currentpage": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.btnQuery();
      }
    },
    "form.pagesize": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.btnQuery();
      }
    },
  },
  created() {
    const self = this;
    //RoleAuthorizeMenu
    self.pageData.MenuIndex = getMenuIndex(self.pageData.PrgName);
    if (self.pageData.MenuIndex === null) {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
  },
};
</script>

<style scoped src="@/assets/css/Cy.css" />
